import ArrowDownIcon from '@repo/ui/components/icons/ArrowDownIcon';
import { Button } from '@repo/ui';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';



import type { NavigationDropdownProps } from '../../../types/Layouts.component-props.types';
const NavigationDropdown = ({
    to,
    name,
    Icon,
    activeTab,
    setActiveTab,
    isSidebarOpen,
    secondaryActiveTab,
    setSecondaryActiveTab,
    navigation = [],
    onLinkClick, // Destructure onLinkClick
}: NavigationDropdownProps) => {
    const { t } = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const handleNavClick = () => {
        // Only set activeTab if there’s no dropdown or it’s not being toggled
        if (!navigation?.length) {
            setActiveTab(t(name));
            setSecondaryActiveTab('');
            onLinkClick?.(); // Call onLinkClick to close sidebar
        }
    };

    return (
        <>
            <NavLink
                to={to}
                onClick={handleNavClick}
                className={cn(
                    'w-full mb-1 flex items-center justify-between hover:text-primery-blue-700 rounded-s-lg py-4 ps-2 pe-4',
                    {
                        'bg-white-blue-50 text-primery-blue-500': activeTab === t(name),
                        'hover:bg-white-blue-50': activeTab !== t(name),
                    },
                )}
            >
                <div className="flex flex-row items-center">
                    <Icon className={cn('w-6 h-6', { 'me-2': isSidebarOpen })} />
                    {isSidebarOpen && <span className="text-start text-nowrap">{t(name)}</span>}
                </div>
                {navigation?.length > 0 && isSidebarOpen && (
                    <Button
                        type="button"
                        variant="ghost"
                        className="flex items-center justify-center bg-inherit border-none shadow-none text-inherit hover:text-primery-blue-500 hover:bg-white-blue-50 transition-none"
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsDropdownOpen(!isDropdownOpen);
                            setActiveTab(t(name)); // Set active tab when opening dropdown
                        }}
                        aria-expanded={isDropdownOpen}
                        aria-controls={`dropdown-${name}`}
                    >
                        <ArrowDownIcon
                            className={cn('w-4 h-4 transition-transform', {
                                'rotate-180': isDropdownOpen,
                            })}
                        />
                    </Button>
                )}
            </NavLink>
            {isDropdownOpen && isSidebarOpen && navigation.length > 0 && (
                <div id={`dropdown-${name}`} className="flex flex-col">
                    {navigation.map((item) => (
                        <NavLink
                            to={item.to}
                            key={t(item.name)}
                            onClick={() => {
                                setSecondaryActiveTab(t(item.name));
                                setActiveTab(t(name)); // Ensure parent is active
                                onLinkClick?.(); // Call onLinkClick to close sidebar
                            }}
                            className={cn(
                                'w-full mb-1 flex items-center justify-between hover:text-primery-blue-700 rounded-s-lg py-4 ps-2 pe-4',
                                {
                                    'bg-primery-blue-900 text-white-blue-50 hover:bg-white-blue-50':
                                        secondaryActiveTab === t(item.name) && activeTab === t(name),
                                    'hover:bg-white-blue-50': secondaryActiveTab !== t(item.name),
                                },
                            )}
                        >
                            <span className={cn('ms-6 text-start', { hidden: !isSidebarOpen })}>{t(item.name)}</span>
                        </NavLink>
                    ))}
                </div>
            )}
        </>
    );
};

export default NavigationDropdown;
